import { render, staticRenderFns } from "./IndicatoreSalvataggio.vue?vue&type=template&id=ee0ced5c&"
import script from "./IndicatoreSalvataggio.vue?vue&type=script&lang=js&"
export * from "./IndicatoreSalvataggio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VIcon,VProgressCircular})
